export const formatTaskDate = (dateValue) => new Date(dateValue).toLocaleDateString();
